import React, { useEffect, useState } from 'react';

import { Table } from 'antd';
const UserTable = ({ users }) => {  // Destructure user from props
    const columns = [
      {
        title: 'First Name',
        dataIndex: 'firstName',
        key: 'firstName',
      },
      {
        title: 'Last Name',
        dataIndex: 'lastName',
        key: 'lastName',
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Phone',
        dataIndex: 'phone',
        key: 'phone',
      },
      {
        title: 'Role',
        dataIndex: ['role', 'name'],
        key: 'role',
      },
      {
        title: 'Workstream',
        dataIndex: ['workstream', 'workstreamName'],
        key: 'workstream',
      },
      {
        title: 'Subworkstream',
        dataIndex: ['subworkstream', 'subworkstreamName'],
        key: 'subworkstream',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
      },
    ];
  
    return (
      <Table
        dataSource={users || []} // Ensure dataSource is always an array
        columns={columns}
        rowKey={(record) => record._id}
        scroll={{ x: 'max-content' }}
        pagination={{ pageSize: 10 }}
      />
    );
  };
export default UserTable  